// Data types are structured as data.category.org.suffix
export const SPATIAL_LAYER_INTERSECT = 'spatial_layer_intersect';

// Medical Guardian emergency address. Nested in the session response under the
// response/category, e.g. response.<org>.data.<category>.emergency_address.
export const EMERGENCY_ADDRESS = 'emergency_address';
